// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0px;
    padding: 0px;
}

/* Navbar Styles */
.navbar-header {
    background: linear-gradient(135deg, #0047AB 0%, #003680 100%);
    color: white;
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    /* position: fixed; */
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    width: 100%;
    margin: 0;
}

.navbar-back-button {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
}

.navbar-back-button:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.navbar-title {
    color: white;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    flex: 1 1;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.navbar-search {
    flex: 2 1;
    max-width: 400px;
    margin: 0 16px;
    position: relative;
}

.navbar-search-container {
    position: relative;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
}

.navbar-search-container:focus-within {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1);
}

.navbar-search-icon {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    margin-left: 12px;
    margin-right: 8px;
    flex-shrink: 0;
}

.navbar-search-input {
    background: transparent;
    border: none;
    color: white;
    font-size: 14px;
    padding: 10px 8px 10px 0;
    flex: 1 1;
    outline: none;
    min-width: 0;
}

.navbar-search-input::placeholder {
    color: rgba(255, 255, 255, 0.6);
    font-style: italic;
}

.navbar-search-input::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.6);
}

.navbar-search-input::-moz-placeholder {
    color: rgba(255, 255, 255, 0.6);
    opacity: 1;
}

.navbar-search-input:-ms-input-placeholder {
    color: rgba(255, 255, 255, 0.6);
}

.navbar-clear-search-icon {
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
    margin-right: 12px;
    margin-left: 8px;
    cursor: pointer;
    padding: 4px;
    border-radius: 50%;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.navbar-clear-search-icon:hover {
    color: white;
    background: rgba(255, 255, 255, 0.1);
    transform: scale(1.1);
}

/* Desktop search - always visible */
.navbar-search-desktop {
    display: block;
}

/* Mobile search components */
.navbar-search-mobile {
    display: none;
}

.navbar-search-toggle {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
}

.navbar-search-toggle:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
}

.navbar-search-expanded {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    animation: searchExpand 0.3s ease;
}

@keyframes searchExpand {
    from {
        opacity: 0;
        transform: scale(0.95) translateY(-5px);
    }

    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

.navbar-search-close {
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: rgba(255, 255, 255, 0.7);
    padding: 4px;
    margin-left: 8px;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.navbar-search-close:hover {
    color: white;
    background: rgba(255, 255, 255, 0.2);
}

.navbar-header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.navbar-logout-button {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    font-size: 14px;
    font-weight: 500;
}

.navbar-logout-text {
    font-size: 14px;
    font-weight: 500;
}

.navbar-logout-button:hover {
    background: rgba(220, 38, 38, 0.2);
    border-color: rgba(220, 38, 38, 0.4);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2);
}

.navbar-profile-dropdown {
    position: relative;
}

.navbar-profile-button {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
}

.navbar-profile-button:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.navbar-profile-icon {
    font-size: 18px;
}

.navbar-profile-dropdown-menu {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    min-width: 280px;
    z-index: 1000;
    overflow: hidden;
    animation: slideDown 0.3s ease;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.navbar-profile-header {
    background: linear-gradient(135deg, #0047AB 0%, #003680 100%);
    color: white;
    padding: 16px 20px;
    border-bottom: 1px solid #e5e7eb;
}

.navbar-profile-header h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
}

.navbar-info-loading {
    padding: 20px;
    text-align: center;
    color: #6b7280;
    font-style: italic;
}

.navbar-profile-content {
    padding: 16px 20px;
}

.navbar-info-item {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
    padding: 8px 0;
    border-bottom: 1px solid #f3f4f6;
}

.navbar-info-item:last-child {
    margin-bottom: 0;
    border-bottom: none;
}

.navbar-info-icon {
    color: #0047AB;
    font-size: 16px;
    flex-shrink: 0;
    width: 20px;
    text-align: center;
}

.navbar-info-label {
    font-weight: 600;
    color: #374151;
    min-width: 80px;
    font-size: 14px;
}

.navbar-info-value {
    color: #6b7280;
    font-size: 14px;
    flex: 1 1;
}

/* Mobile Responsive */
@media (max-width: 768px) {
    .navbar-header {
        margin-top: 0px !important;
        margin-left: 0px !important;
        margin-right: 0px !important;
        padding: 6px 8px;
        flex-wrap: nowrap;
        min-height: 56px;
        justify-content: space-between;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        width: 100%;
        gap: 8px;
    }

    .navbar-back-button {
        padding: 4px 6px;
        font-size: 11px;
        gap: 2px;
        min-width: 32px;
        flex-shrink: 0;
        order: 1;
    }

    .navbar-back-button span {
        display: none;
    }

    .navbar-back-button:hover span {
        display: inline;
    }

    .navbar-title {
        font-size: 13px;
        margin: 0;
        white-space: nowrap;
        overflow: visible;
        text-overflow: unset;
        flex: 1 1;
        min-width: 80px;
        max-width: none;
        text-align: center;
        padding: 0 4px;
        order: 2;
    }

    /* Mobile search styles */
    .navbar-search {
        flex: 0 0 auto;
        max-width: none;
        margin: 0;
        order: 3;
        min-width: auto;
    }

    /* Hide desktop search on mobile */
    .navbar-search-desktop {
        display: none;
    }

    /* Show mobile search on mobile */
    .navbar-search-mobile {
        display: block;
        margin-left: 0;
    }

    .navbar-search-container {
        border-radius: 6px;
    }

    .navbar-search-icon {
        font-size: 12px;
        margin-left: 8px;
        margin-right: 4px;
    }

    .navbar-search-input {
        font-size: 12px;
        padding: 6px 4px 6px 0;
    }

    .navbar-clear-search-icon {
        font-size: 10px;
        margin-right: 8px;
        margin-left: 4px;
        padding: 2px;
    }

    .navbar-search-toggle {
        padding: 6px 10px;
    }

    .navbar-search-toggle .navbar-search-icon {
        font-size: 12px;
        margin: 0;
    }

    .navbar-search-expanded {
        position: fixed;
        top: 56px;
        left: 8px;
        right: 8px;
        z-index: 1001;
        background: rgba(0, 71, 171, 0.98) !important;
        backdrop-filter: blur(20px);
        border-radius: 8px;
        padding: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        border: 1px solid rgba(255, 255, 255, 0.2);
    }

    .navbar-search-close {
        padding: 6px;
        margin-left: 6px;
    }

    .navbar-header-actions {
        gap: 4px;
        flex-shrink: 0;
        min-width: 60px;
        order: 4;
    }

    .navbar-logout-button {
        padding: 6px 8px;
        font-size: 12px;
        gap: 4px;
        display: none !important;
    }

    .navbar-logout-text {
        font-size: 12px;
    }

    .navbar-profile-button {
        width: 28px;
        height: 28px;
    }

    .navbar-profile-icon {
        font-size: 14px;
    }

    .navbar-profile-dropdown-menu {
        min-width: 240px;
        right: -4px;
        top: calc(100% + 2px);
        max-width: calc(100vw - 20px);
    }

    .navbar-profile-header {
        padding: 12px 16px;
    }

    .navbar-profile-header h4 {
        font-size: 14px;
    }

    .navbar-info-loading {
        padding: 16px;
        font-size: 13px;
    }

    .navbar-profile-content {
        padding: 12px 16px;
    }

    .navbar-info-item {
        gap: 8px;
        margin-bottom: 8px;
        padding: 6px 0;
        flex-direction: row !important;
        align-items: flex-start;
    }

    .navbar-info-item:last-child {
        margin-bottom: 0;
    }

    .navbar-info-icon {
        font-size: 14px;
        width: 16px;
        margin-bottom: 2px;
    }

    .navbar-info-label {
        min-width: auto;
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 2px;
    }

    .navbar-info-value {
        font-size: 12px;
        word-break: break-word;
        line-height: 1.3;
    }

    /* Adjust language switcher for mobile */
    .navbar-header-actions .language-switcher {
        transform: scale(0.8);
        margin-right: -8px;
    }

    .navbar-header-actions .language-switcher .language-dropdown-button {
        padding: 4px 8px !important;
        font-size: 11px !important;
        min-width: 32px !important;
        height: 32px !important;
    }

    .navbar-header-actions .language-switcher .language-dropdown-menu {
        top: calc(100% + 4px) !important;
        right: 0 !important;
        left: auto !important;
        min-width: 120px !important;
        font-size: 12px !important;
    }

    .navbar-header-actions .language-switcher .language-option {
        padding: 6px 8px !important;
        font-size: 11px !important;
    }

    /* Hide desktop support section on mobile */
    .navbar-support-section-desktop {
        display: none !important;
    }
}

/* Extra Small Mobile (iPhone SE, etc.) */
@media (max-width: 375px) {
    .navbar-header {
        margin-top: 0px !important;
        margin-left: 0px !important;
        margin-right: 0px !important;
        padding: 4px 6px;
        min-height: 52px;
        justify-content: space-between;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        width: 100%;
        gap: 4px;
    }

    .navbar-back-button {
        padding: 3px 4px;
        font-size: 10px;
        min-width: 28px;
        flex-shrink: 0;
        order: 1;
    }

    .navbar-title {
        font-size: 12px;
        margin: 0;
        min-width: 60px;
        max-width: none;
        padding: 0 2px;
        flex: 1 1;
        white-space: nowrap;
        overflow: visible;
        text-overflow: unset;
        order: 2;
    }

    /* Extra small mobile search styles */
    .navbar-search {
        flex: 0 0 auto;
        max-width: none;
        margin: 0;
        min-width: auto;
        order: 3;
    }

    /* Hide desktop search on extra small mobile */
    .navbar-search-desktop {
        display: none;
    }

    /* Show mobile search on extra small mobile */
    .navbar-search-mobile {
        display: block;
    }

    .navbar-search-container {
        border-radius: 4px;
    }

    .navbar-search-icon {
        font-size: 10px;
        margin-left: 6px;
        margin-right: 3px;
    }

    .navbar-search-input {
        font-size: 11px;
        padding: 5px 3px 5px 0;
    }

    .navbar-clear-search-icon {
        font-size: 9px;
        margin-right: 6px;
        margin-left: 3px;
        padding: 1px;
    }

    .navbar-search-toggle {
        padding: 5px 8px;
    }

    .navbar-search-toggle .navbar-search-icon {
        font-size: 10px;
        margin: 0;
    }

    .navbar-search-expanded {
        position: fixed;
        top: 52px;
        left: 6px;
        right: 6px;
        z-index: 1001;
        background: rgba(0, 71, 171, 0.98);
        backdrop-filter: blur(20px);
        border-radius: 6px;
        padding: 6px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
        border: 1px solid rgba(255, 255, 255, 0.2);
    }

    .navbar-search-close {
        padding: 4px;
        margin-left: 4px;
    }

    .navbar-header-actions {
        gap: 2px;
        min-width: 50px;
        flex-shrink: 0;
        order: 4;
    }

    .navbar-logout-button {
        padding: 4px 6px;
        font-size: 10px;
        gap: 3px;
        display: none !important;
    }

    .navbar-logout-text {
        font-size: 10px;
    }

    .navbar-profile-button {
        width: 24px;
        height: 24px;
    }

    .navbar-profile-icon {
        font-size: 12px;
    }

    .navbar-profile-dropdown-menu {
        min-width: 220px;
        right: -6px;
        top: calc(100% + 2px);
        max-width: calc(100vw - 16px);
    }

    .navbar-info-item {
        gap: 6px;
        margin-bottom: 6px;
    }

    .navbar-info-label {
        font-size: 11px;
    }

    .navbar-info-value {
        font-size: 11px;
    }

    /* Extra small mobile language switcher */
    .navbar-header-actions .language-switcher {
        transform: scale(0.7);
        margin-right: -10px;
    }

    .navbar-header-actions .language-switcher .language-dropdown-button {
        padding: 3px 6px !important;
        font-size: 10px !important;
        min-width: 28px !important;
        height: 28px !important;
    }

    .navbar-header-actions .language-switcher .language-dropdown-menu {
        min-width: 100px !important;
        font-size: 11px !important;
    }

    .navbar-header-actions .language-switcher .language-option {
        padding: 4px 6px !important;
        font-size: 10px !important;
    }
}

/* Tablet Responsive */
@media (min-width: 769px) and (max-width: 1024px) {
    .navbar-header {
        margin: 0 !important;
        padding: 7px 14px;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        width: 100%;
    }

    .navbar-title {
        font-size: 19px;
    }

    .navbar-profile-dropdown-menu {
        min-width: 270px;
    }
}

/* Desktop Support Section Styles */
.navbar-support-section-desktop {
    display: flex;
    align-items: center;
}

.navbar-support-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    background: rgba(255, 255, 255, 0.15);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.navbar-support-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.4);
    transform: translateY(-1px);
}

.navbar-support-btn:active {
    transform: translateY(0);
}

.navbar-support-text {
    font-size: 13px;
    font-weight: 600;
}

/* Navbar Profile Logout Button */
.navbar-profile-actions {
    border-top: 1px solid #e0e0e0;
    padding: 8px 12px;
    display: flex;
    gap: 10px;
    /* margin: 0 -12px -12px; */
}

.navbar-profile-logout-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: fit-content;
    padding: 10px 16px;
    background: transparent;
    /* border: none; */
    border-radius: 6px;
    color: #dc2626;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.navbar-profile-logout-btn:hover {
    background: #fef2f2;
    color: #b91c1c;
}

.navbar-profile-logout-btn:active {
    background: #fee2e2;
    transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,6DAA6D;IAC7D,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yCAAyC;IACzC,qBAAqB;IACrB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,WAAW;IACX,SAAS;AACb;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,SAAO;IACP,yCAAyC;AAC7C;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,wBAAwB;IACxB,SAAO;IACP,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA,oCAAoC;AACpC;IACI,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,+BAA+B;IAC/B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;IACzB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAO;AACX;;AAEA,sBAAsB;AACtB;IACI;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,4BAA4B;QAC5B,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,8BAA8B;QAC9B,eAAe;QACf,OAAO;QACP,QAAQ;QACR,MAAM;QACN,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,QAAQ;QACR,eAAe;QACf,cAAc;QACd,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;QACpB,SAAO;QACP,eAAe;QACf,eAAe;QACf,kBAAkB;QAClB,cAAc;QACd,QAAQ;IACZ;;IAEA,yBAAyB;IACzB;QACI,cAAc;QACd,eAAe;QACf,SAAS;QACT,QAAQ;QACR,eAAe;IACnB;;IAEA,kCAAkC;IAClC;QACI,aAAa;IACjB;;IAEA,iCAAiC;IACjC;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,SAAS;QACT,SAAS;QACT,UAAU;QACV,aAAa;QACb,6CAA6C;QAC7C,2BAA2B;QAC3B,kBAAkB;QAClB,YAAY;QACZ,yCAAyC;QACzC,0CAA0C;IAC9C;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,QAAQ;QACR,cAAc;QACd,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,QAAQ;QACR,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,qBAAqB;QACrB,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,kBAAkB;QAClB,cAAc;QACd,8BAA8B;QAC9B,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA,wCAAwC;IACxC;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;QACI,gCAAgC;QAChC,mBAAmB;QACnB,qBAAqB;QACrB,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA,2CAA2C;IAC3C;QACI,wBAAwB;IAC5B;AACJ;;AAEA,yCAAyC;AACzC;IACI;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,4BAA4B;QAC5B,gBAAgB;QAChB,gBAAgB;QAChB,8BAA8B;QAC9B,eAAe;QACf,OAAO;QACP,QAAQ;QACR,MAAM;QACN,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,eAAe;QACf,cAAc;QACd,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,SAAS;QACT,eAAe;QACf,eAAe;QACf,cAAc;QACd,SAAO;QACP,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;QACpB,QAAQ;IACZ;;IAEA,qCAAqC;IACrC;QACI,cAAc;QACd,eAAe;QACf,SAAS;QACT,eAAe;QACf,QAAQ;IACZ;;IAEA,8CAA8C;IAC9C;QACI,aAAa;IACjB;;IAEA,6CAA6C;IAC7C;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,SAAS;QACT,SAAS;QACT,UAAU;QACV,aAAa;QACb,kCAAkC;QAClC,2BAA2B;QAC3B,kBAAkB;QAClB,YAAY;QACZ,yCAAyC;QACzC,0CAA0C;IAC9C;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,QAAQ;QACR,eAAe;QACf,cAAc;QACd,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,QAAQ;QACR,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,qBAAqB;QACrB,6BAA6B;IACjC;;IAEA;QACI,QAAQ;QACR,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,yCAAyC;IACzC;QACI,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,oBAAoB;QACpB,iBAAiB;QACjB,eAAe;QACf,OAAO;QACP,QAAQ;QACR,MAAM;QACN,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,qCAAqC;IACrC,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B","sourcesContent":["* {\n    margin: 0px;\n    padding: 0px;\n}\n\n/* Navbar Styles */\n.navbar-header {\n    background: linear-gradient(135deg, #0047AB 0%, #003680 100%);\n    color: white;\n    padding: 8px 12px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    /* position: fixed; */\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 99;\n    width: 100%;\n    margin: 0;\n}\n\n.navbar-back-button {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    color: white;\n    padding: 8px 16px;\n    border-radius: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.3s ease;\n    backdrop-filter: blur(10px);\n}\n\n.navbar-back-button:hover {\n    background: rgba(255, 255, 255, 0.2);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.navbar-title {\n    color: white;\n    text-align: center;\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0;\n    flex: 1;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.navbar-search {\n    flex: 2;\n    max-width: 400px;\n    margin: 0 16px;\n    position: relative;\n}\n\n.navbar-search-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 8px;\n    backdrop-filter: blur(10px);\n    transition: all 0.3s ease;\n}\n\n.navbar-search-container:focus-within {\n    background: rgba(255, 255, 255, 0.15);\n    border-color: rgba(255, 255, 255, 0.3);\n    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1);\n}\n\n.navbar-search-icon {\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 14px;\n    margin-left: 12px;\n    margin-right: 8px;\n    flex-shrink: 0;\n}\n\n.navbar-search-input {\n    background: transparent;\n    border: none;\n    color: white;\n    font-size: 14px;\n    padding: 10px 8px 10px 0;\n    flex: 1;\n    outline: none;\n    min-width: 0;\n}\n\n.navbar-search-input::placeholder {\n    color: rgba(255, 255, 255, 0.6);\n    font-style: italic;\n}\n\n.navbar-search-input::-webkit-input-placeholder {\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.navbar-search-input::-moz-placeholder {\n    color: rgba(255, 255, 255, 0.6);\n    opacity: 1;\n}\n\n.navbar-search-input:-ms-input-placeholder {\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.navbar-clear-search-icon {\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 12px;\n    margin-right: 12px;\n    margin-left: 8px;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 50%;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n}\n\n.navbar-clear-search-icon:hover {\n    color: white;\n    background: rgba(255, 255, 255, 0.1);\n    transform: scale(1.1);\n}\n\n/* Desktop search - always visible */\n.navbar-search-desktop {\n    display: block;\n}\n\n/* Mobile search components */\n.navbar-search-mobile {\n    display: none;\n}\n\n.navbar-search-toggle {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 8px;\n    padding: 8px 12px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n    backdrop-filter: blur(10px);\n}\n\n.navbar-search-toggle:hover {\n    background: rgba(255, 255, 255, 0.2);\n    transform: translateY(-1px);\n}\n\n.navbar-search-expanded {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    animation: searchExpand 0.3s ease;\n}\n\n@keyframes searchExpand {\n    from {\n        opacity: 0;\n        transform: scale(0.95) translateY(-5px);\n    }\n\n    to {\n        opacity: 1;\n        transform: scale(1) translateY(0);\n    }\n}\n\n.navbar-search-close {\n    background: rgba(255, 255, 255, 0.1);\n    border: none;\n    color: rgba(255, 255, 255, 0.7);\n    padding: 4px;\n    margin-left: 8px;\n    cursor: pointer;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.navbar-search-close:hover {\n    color: white;\n    background: rgba(255, 255, 255, 0.2);\n}\n\n.navbar-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-shrink: 0;\n}\n\n.navbar-logout-button {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    color: white;\n    padding: 8px 12px;\n    border-radius: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    transition: all 0.3s ease;\n    backdrop-filter: blur(10px);\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.navbar-logout-text {\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.navbar-logout-button:hover {\n    background: rgba(220, 38, 38, 0.2);\n    border-color: rgba(220, 38, 38, 0.4);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2);\n}\n\n.navbar-profile-dropdown {\n    position: relative;\n}\n\n.navbar-profile-button {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    color: white;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n    backdrop-filter: blur(10px);\n}\n\n.navbar-profile-button:hover {\n    background: rgba(255, 255, 255, 0.2);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.navbar-profile-icon {\n    font-size: 18px;\n}\n\n.navbar-profile-dropdown-menu {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n    min-width: 280px;\n    z-index: 1000;\n    overflow: hidden;\n    animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.navbar-profile-header {\n    background: linear-gradient(135deg, #0047AB 0%, #003680 100%);\n    color: white;\n    padding: 16px 20px;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.navbar-profile-header h4 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.navbar-info-loading {\n    padding: 20px;\n    text-align: center;\n    color: #6b7280;\n    font-style: italic;\n}\n\n.navbar-profile-content {\n    padding: 16px 20px;\n}\n\n.navbar-info-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n    padding: 8px 0;\n    border-bottom: 1px solid #f3f4f6;\n}\n\n.navbar-info-item:last-child {\n    margin-bottom: 0;\n    border-bottom: none;\n}\n\n.navbar-info-icon {\n    color: #0047AB;\n    font-size: 16px;\n    flex-shrink: 0;\n    width: 20px;\n    text-align: center;\n}\n\n.navbar-info-label {\n    font-weight: 600;\n    color: #374151;\n    min-width: 80px;\n    font-size: 14px;\n}\n\n.navbar-info-value {\n    color: #6b7280;\n    font-size: 14px;\n    flex: 1;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n    .navbar-header {\n        margin-top: 0px !important;\n        margin-left: 0px !important;\n        margin-right: 0px !important;\n        padding: 6px 8px;\n        flex-wrap: nowrap;\n        min-height: 56px;\n        justify-content: space-between;\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: 0;\n        width: 100%;\n        gap: 8px;\n    }\n\n    .navbar-back-button {\n        padding: 4px 6px;\n        font-size: 11px;\n        gap: 2px;\n        min-width: 32px;\n        flex-shrink: 0;\n        order: 1;\n    }\n\n    .navbar-back-button span {\n        display: none;\n    }\n\n    .navbar-back-button:hover span {\n        display: inline;\n    }\n\n    .navbar-title {\n        font-size: 13px;\n        margin: 0;\n        white-space: nowrap;\n        overflow: visible;\n        text-overflow: unset;\n        flex: 1;\n        min-width: 80px;\n        max-width: none;\n        text-align: center;\n        padding: 0 4px;\n        order: 2;\n    }\n\n    /* Mobile search styles */\n    .navbar-search {\n        flex: 0 0 auto;\n        max-width: none;\n        margin: 0;\n        order: 3;\n        min-width: auto;\n    }\n\n    /* Hide desktop search on mobile */\n    .navbar-search-desktop {\n        display: none;\n    }\n\n    /* Show mobile search on mobile */\n    .navbar-search-mobile {\n        display: block;\n        margin-left: 0;\n    }\n\n    .navbar-search-container {\n        border-radius: 6px;\n    }\n\n    .navbar-search-icon {\n        font-size: 12px;\n        margin-left: 8px;\n        margin-right: 4px;\n    }\n\n    .navbar-search-input {\n        font-size: 12px;\n        padding: 6px 4px 6px 0;\n    }\n\n    .navbar-clear-search-icon {\n        font-size: 10px;\n        margin-right: 8px;\n        margin-left: 4px;\n        padding: 2px;\n    }\n\n    .navbar-search-toggle {\n        padding: 6px 10px;\n    }\n\n    .navbar-search-toggle .navbar-search-icon {\n        font-size: 12px;\n        margin: 0;\n    }\n\n    .navbar-search-expanded {\n        position: fixed;\n        top: 56px;\n        left: 8px;\n        right: 8px;\n        z-index: 1001;\n        background: rgba(0, 71, 171, 0.98) !important;\n        backdrop-filter: blur(20px);\n        border-radius: 8px;\n        padding: 8px;\n        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n        border: 1px solid rgba(255, 255, 255, 0.2);\n    }\n\n    .navbar-search-close {\n        padding: 6px;\n        margin-left: 6px;\n    }\n\n    .navbar-header-actions {\n        gap: 4px;\n        flex-shrink: 0;\n        min-width: 60px;\n        order: 4;\n    }\n\n    .navbar-logout-button {\n        padding: 6px 8px;\n        font-size: 12px;\n        gap: 4px;\n        display: none !important;\n    }\n\n    .navbar-logout-text {\n        font-size: 12px;\n    }\n\n    .navbar-profile-button {\n        width: 28px;\n        height: 28px;\n    }\n\n    .navbar-profile-icon {\n        font-size: 14px;\n    }\n\n    .navbar-profile-dropdown-menu {\n        min-width: 240px;\n        right: -4px;\n        top: calc(100% + 2px);\n        max-width: calc(100vw - 20px);\n    }\n\n    .navbar-profile-header {\n        padding: 12px 16px;\n    }\n\n    .navbar-profile-header h4 {\n        font-size: 14px;\n    }\n\n    .navbar-info-loading {\n        padding: 16px;\n        font-size: 13px;\n    }\n\n    .navbar-profile-content {\n        padding: 12px 16px;\n    }\n\n    .navbar-info-item {\n        gap: 8px;\n        margin-bottom: 8px;\n        padding: 6px 0;\n        flex-direction: row !important;\n        align-items: flex-start;\n    }\n\n    .navbar-info-item:last-child {\n        margin-bottom: 0;\n    }\n\n    .navbar-info-icon {\n        font-size: 14px;\n        width: 16px;\n        margin-bottom: 2px;\n    }\n\n    .navbar-info-label {\n        min-width: auto;\n        font-size: 12px;\n        font-weight: 600;\n        margin-bottom: 2px;\n    }\n\n    .navbar-info-value {\n        font-size: 12px;\n        word-break: break-word;\n        line-height: 1.3;\n    }\n\n    /* Adjust language switcher for mobile */\n    .navbar-header-actions .language-switcher {\n        transform: scale(0.8);\n        margin-right: -8px;\n    }\n\n    .navbar-header-actions .language-switcher .language-dropdown-button {\n        padding: 4px 8px !important;\n        font-size: 11px !important;\n        min-width: 32px !important;\n        height: 32px !important;\n    }\n\n    .navbar-header-actions .language-switcher .language-dropdown-menu {\n        top: calc(100% + 4px) !important;\n        right: 0 !important;\n        left: auto !important;\n        min-width: 120px !important;\n        font-size: 12px !important;\n    }\n\n    .navbar-header-actions .language-switcher .language-option {\n        padding: 6px 8px !important;\n        font-size: 11px !important;\n    }\n\n    /* Hide desktop support section on mobile */\n    .navbar-support-section-desktop {\n        display: none !important;\n    }\n}\n\n/* Extra Small Mobile (iPhone SE, etc.) */\n@media (max-width: 375px) {\n    .navbar-header {\n        margin-top: 0px !important;\n        margin-left: 0px !important;\n        margin-right: 0px !important;\n        padding: 4px 6px;\n        min-height: 52px;\n        justify-content: space-between;\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: 0;\n        width: 100%;\n        gap: 4px;\n    }\n\n    .navbar-back-button {\n        padding: 3px 4px;\n        font-size: 10px;\n        min-width: 28px;\n        flex-shrink: 0;\n        order: 1;\n    }\n\n    .navbar-title {\n        font-size: 12px;\n        margin: 0;\n        min-width: 60px;\n        max-width: none;\n        padding: 0 2px;\n        flex: 1;\n        white-space: nowrap;\n        overflow: visible;\n        text-overflow: unset;\n        order: 2;\n    }\n\n    /* Extra small mobile search styles */\n    .navbar-search {\n        flex: 0 0 auto;\n        max-width: none;\n        margin: 0;\n        min-width: auto;\n        order: 3;\n    }\n\n    /* Hide desktop search on extra small mobile */\n    .navbar-search-desktop {\n        display: none;\n    }\n\n    /* Show mobile search on extra small mobile */\n    .navbar-search-mobile {\n        display: block;\n    }\n\n    .navbar-search-container {\n        border-radius: 4px;\n    }\n\n    .navbar-search-icon {\n        font-size: 10px;\n        margin-left: 6px;\n        margin-right: 3px;\n    }\n\n    .navbar-search-input {\n        font-size: 11px;\n        padding: 5px 3px 5px 0;\n    }\n\n    .navbar-clear-search-icon {\n        font-size: 9px;\n        margin-right: 6px;\n        margin-left: 3px;\n        padding: 1px;\n    }\n\n    .navbar-search-toggle {\n        padding: 5px 8px;\n    }\n\n    .navbar-search-toggle .navbar-search-icon {\n        font-size: 10px;\n        margin: 0;\n    }\n\n    .navbar-search-expanded {\n        position: fixed;\n        top: 52px;\n        left: 6px;\n        right: 6px;\n        z-index: 1001;\n        background: rgba(0, 71, 171, 0.98);\n        backdrop-filter: blur(20px);\n        border-radius: 6px;\n        padding: 6px;\n        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n        border: 1px solid rgba(255, 255, 255, 0.2);\n    }\n\n    .navbar-search-close {\n        padding: 4px;\n        margin-left: 4px;\n    }\n\n    .navbar-header-actions {\n        gap: 2px;\n        min-width: 50px;\n        flex-shrink: 0;\n        order: 4;\n    }\n\n    .navbar-logout-button {\n        padding: 4px 6px;\n        font-size: 10px;\n        gap: 3px;\n        display: none !important;\n    }\n\n    .navbar-logout-text {\n        font-size: 10px;\n    }\n\n    .navbar-profile-button {\n        width: 24px;\n        height: 24px;\n    }\n\n    .navbar-profile-icon {\n        font-size: 12px;\n    }\n\n    .navbar-profile-dropdown-menu {\n        min-width: 220px;\n        right: -6px;\n        top: calc(100% + 2px);\n        max-width: calc(100vw - 16px);\n    }\n\n    .navbar-info-item {\n        gap: 6px;\n        margin-bottom: 6px;\n    }\n\n    .navbar-info-label {\n        font-size: 11px;\n    }\n\n    .navbar-info-value {\n        font-size: 11px;\n    }\n\n    /* Extra small mobile language switcher */\n    .navbar-header-actions .language-switcher {\n        transform: scale(0.7);\n        margin-right: -10px;\n    }\n\n    .navbar-header-actions .language-switcher .language-dropdown-button {\n        padding: 3px 6px !important;\n        font-size: 10px !important;\n        min-width: 28px !important;\n        height: 28px !important;\n    }\n\n    .navbar-header-actions .language-switcher .language-dropdown-menu {\n        min-width: 100px !important;\n        font-size: 11px !important;\n    }\n\n    .navbar-header-actions .language-switcher .language-option {\n        padding: 4px 6px !important;\n        font-size: 10px !important;\n    }\n}\n\n/* Tablet Responsive */\n@media (min-width: 769px) and (max-width: 1024px) {\n    .navbar-header {\n        margin: 0 !important;\n        padding: 7px 14px;\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: 0;\n        width: 100%;\n    }\n\n    .navbar-title {\n        font-size: 19px;\n    }\n\n    .navbar-profile-dropdown-menu {\n        min-width: 270px;\n    }\n}\n\n/* Desktop Support Section Styles */\n.navbar-support-section-desktop {\n    display: flex;\n    align-items: center;\n}\n\n.navbar-support-btn {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 12px;\n    background: rgba(255, 255, 255, 0.15);\n    color: white;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.navbar-support-btn:hover {\n    background: rgba(255, 255, 255, 0.3);\n    border-color: rgba(255, 255, 255, 0.4);\n    transform: translateY(-1px);\n}\n\n.navbar-support-btn:active {\n    transform: translateY(0);\n}\n\n.navbar-support-text {\n    font-size: 13px;\n    font-weight: 600;\n}\n\n/* Navbar Profile Logout Button */\n.navbar-profile-actions {\n    border-top: 1px solid #e0e0e0;\n    padding: 8px 12px;\n    display: flex;\n    gap: 10px;\n    /* margin: 0 -12px -12px; */\n}\n\n.navbar-profile-logout-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    width: fit-content;\n    padding: 10px 16px;\n    background: transparent;\n    /* border: none; */\n    border-radius: 6px;\n    color: #dc2626;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.navbar-profile-logout-btn:hover {\n    background: #fef2f2;\n    color: #b91c1c;\n}\n\n.navbar-profile-logout-btn:active {\n    background: #fee2e2;\n    transform: translateY(0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
